/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateTicketRequest } from '../models/create-ticket-request';
import { CreateTicketResponse } from '../models/create-ticket-response';

@Injectable({
  providedIn: 'root',
})
export class TicketsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createTicket
   */
  static readonly CreateTicketPath = '/ticket';

  /**
   * Create a new ticket.
   *
   * Creates a new ticket. If the user (identified by email) does not exist, a new user record is created automatically.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTicket()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTicket$Response(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * The ticket creation payload.
     */
    body: CreateTicketRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CreateTicketResponse>> {

    const rb = new RequestBuilder(this.rootUrl, TicketsService.CreateTicketPath, 'post');
    if (params) {
      rb.header('x-tenant-id', params['x-tenant-id'], {});
      rb.header('x-persona', params['x-persona'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateTicketResponse>;
      })
    );
  }

  /**
   * Create a new ticket.
   *
   * Creates a new ticket. If the user (identified by email) does not exist, a new user record is created automatically.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTicket$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTicket(params: {

    /**
     * The tenant code
     */
    'x-tenant-id': string;

    /**
     * The audience of the return data
     */
    'x-persona'?: string;

    /**
     * The ticket creation payload.
     */
    body: CreateTicketRequest
  },
  context?: HttpContext

): Observable<CreateTicketResponse> {

    return this.createTicket$Response(params,context).pipe(
      map((r: StrictHttpResponse<CreateTicketResponse>) => r.body as CreateTicketResponse)
    );
  }

}
